module.exports = __webpack_public_path__ + "img/nav_salary.bbd33736.png";